import {
  TAddOn,
  TAddOnRules,
  TPlan,
} from "@/components/Checkout/types.checkout";
import ShowAutoDownload from "@/components/Onboarding/ShowAutoDownload";
import ActiveSaleBanner from "@/components/SaleMode/ActiveSaleBanner";
import { TUserPlanData } from "@/types/plan-data";
import PaymentInvoice from "../../components/AccountDetails/PaymentInvoice/PaymentInvoice";
import DownloadLinks from "../../tabs/AccountGeneral/DownloadLinks";
import FacebookBanner from "../../tabs/AccountGeneral/FacebookBanner";
import VerifyEmailBanner from "../../tabs/AccountGeneral/VerifyEmailBanner";
import { DashboardService } from "../service.dashboard";
import { useDashboard } from "../useDashboard";
import DashboardProductList from "./DashboardProductList";
import NoSubscription from "./NoSubscription";
import PaymentAndBilling from "./PaymentAndBilling";
import SubscriptionList from "./SubscriptionList";
import YearlyUpsale from "./YearlyUpsale";

type DashboardMainProps = {
  userPlanData?: TUserPlanData;
  userPlanDataLoading: boolean;
  planCards: TPlan[];
  addOnCards: TAddOn[];
  addOnRules: TAddOnRules[];
};

export const DashboardContent = (props: DashboardMainProps) => {
  const Config = DashboardService.Config;
  const {
    UserPlan,
    planActionType,
    Handlers,
    isEmailVerified,
    hasSubscription,
    showDownloadLinks,
    showYearlyBanner,
    switchIntervalCopy,
    showProductList,
    isLoading,
    isReactivating,
    isResuming,
    planCards,
    addOnCards,
    addOnRules,
  } = useDashboard(props);

  return (
    <div className="pt-14 sm:pt-20">
      <div className="mt-4 mb-6 space-y-5">
        <ShowAutoDownload />

        {showDownloadLinks && <DownloadLinks darkBackPanel />}

        {/* banners goes here */}
        <ActiveSaleBanner variant="permotion" />

        {showDownloadLinks && (
          <div className="app-container">
            {!isEmailVerified ? <VerifyEmailBanner /> : <FacebookBanner />}
          </div>
        )}
      </div>

      <div className="app-container space-y-5 pb-6">
        {hasSubscription ? (
          <SubscriptionList
            userPlan={UserPlan}
            planActionType={planActionType}
            loading={isLoading}
            isReactivating={isReactivating}
            isResuming={isResuming}
            handlers={Handlers}
          />
        ) : (
          <NoSubscription copyConfig={Config.noSubscriptionList} />
        )}

        {showYearlyBanner && (
          <YearlyUpsale
            copyConfig={Config.yearly_plan_sale_banner}
            switchIntervalCopy={switchIntervalCopy}
            currentPeriodEnd={UserPlan.currentPeriodEnd}
            billingPeriod={UserPlan.billingPeriod}
            ownedPlanList={UserPlan.ownedPlanList}
            loading={isLoading}
            isV1={!UserPlan.IS_USER_ON_PRICING_V2}
          />
        )}
      </div>

      {showProductList && (
        <DashboardProductList
          planActionType={planActionType}
          billingPeriod={UserPlan.billingPeriod}
          rawUserProductIds={UserPlan.rawUserProductIds}
          rawUserProductIdV1={props.userPlanData?.productRefId}
          planCards={planCards}
          addOnCards={addOnCards}
          addOnRules={addOnRules}
          ownedAddOnItemList={UserPlan.ownedAddOnItemList}
          isFounder={UserPlan.isFounder}
        />
      )}

      {!!UserPlan.planStatus && (
        <div className="space-y-5 pt-6">
          <PaymentAndBilling />

          <PaymentInvoice />

          {!UserPlan.isPlanOnTrial ? (
            <DownloadLinks className="bg-[#FAF7F2] py-6" />
          ) : (
            <div /> // keep this
          )}
        </div>
      )}
    </div>
  );
};
